import React, { FC } from 'react';
import { Checkbox, Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useContentView } from '../ContentViewContext';
import Container from '../../../components/Container';
import { hasNarrowingFilter } from '../filterNarrowing';

export const ToggleSelectAllCheckbox: FC = () => {
  const { t } = useTranslation('components');
  const { selectionState, hasFilterApplied, showImported, filterValues } = useContentView();
  const { allSelected, someSelected, selectAll, deselectAll, selectedCount } = selectionState;

  const toggleSelectAll = () => {
    if (!allSelected || someSelected) {
      selectAll();
    } else {
      deselectAll();
    }
  };

  // The imported view lists exactly what "all" covers, so only a narrowing filter disables it.
  const disabled = showImported ? hasNarrowingFilter(filterValues) : hasFilterApplied;

  const label = allSelected ? t('ToggleSelectAllCheckbox.DeselectAll') : t('ToggleSelectAllCheckbox.SelectAll');

  return (
    <Container left>
      <Tooltip title={label}>
        <Checkbox
          color='secondary'
          edge='start'
          sx={{ ml: '-14px' }}
          checked={allSelected}
          indeterminate={someSelected}
          onClick={toggleSelectAll}
          aria-label={label}
          disabled={disabled}
        />
      </Tooltip>
      <Typography
        sx={{ visibility: selectedCount > 0 ? 'visible' : 'hidden' }}
        variant='caption'
        color='textSecondary'
        noWrap>
        {t('ToggleSelectAllCheckbox.CountItemsSelected', { count: selectedCount })}
      </Typography>
    </Container>
  );
};

export default ToggleSelectAllCheckbox;
